import { TSegmentOcrForm } from '../types';

const ROTULO_FORM_DEFAULT_VALUES: TSegmentOcrForm = {
  start_datetime: null,
  end_datetime: null,
  segment_id: '',
  text: '',
  review_state: 1,
};

export { ROTULO_FORM_DEFAULT_VALUES };
